import goods from './GoodsHeight';

export default goods;
